import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Link from "@material-ui/core/Link";

const useStyles = makeStyles((theme) => ({
  footer: {
    display: "flex",
    justifyContent: "center",
    padding: theme.spacing(4),
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(0),
      width: "50%",
      fontSize: "0.75rem",
      margin: "auto"
    },
  },
  linksList: {
    listStyleType: "none",
    textAlign: "center",
    display: "inline-flex",
    justifyContent: "space-between",
    "& li > a": {
      color: theme.palette.text.primary,
      padding: theme.spacing(4),
      [theme.breakpoints.down("sm")]: {
        padding: theme.spacing(1),
      },
    },
  },
}));

const Footer = () => {
  const classes = useStyles();

  return (
    <footer className={classes.footer}>
      <div>
        <ul className={classes.linksList}>
          <li>
            <Link
              target="_blank"
              rel="noopener"
              href="https://gofreem.de/datenschutz"
              underline="always"
            >
              Datenschutz
            </Link>
          </li>
          |
          <li>
            <Link
              target="_blank"
              rel="noopener"
              href="https://gofreem.de/nutzungsbedingungen"
              underline="always"
            >
              Nutzungsbedingungen
            </Link>
          </li>
        </ul>
      </div>
    </footer>
  );
};

export default Footer;
